import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import Layout from '../components/Layout'
import {fetchMatrixOpinion} from '../redux/features/matrixOpinion.feature';
import {BASE_URL} from '../utils/commonUrl';
import {Button} from 'primereact/button';
import axios from 'axios';
import MatrixOpinionForm from './forms/MatrixOpinionForm';
import {Toast} from 'primereact/toast';
import {Dialog} from 'primereact/dialog';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const MatrixOpinion = () => {
    const dispatch = useDispatch();
    const {matrixOpinion} = useSelector((state) => {
        return state["matrixOpinion"]
    })

    const primeToast = useRef(null)

    const [save, setSave] = useState({loading: false, success: true, message: ''});
    const [matrixOpinionItem, setMatrixOpinionItem] = useState({
        roleMatrixOpinionID: 0,
        title: '',
        description: "",
        weight: 0,
        active: true,        
    })
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);

    useEffect(() => {
        initFilters1();
        dispatch(fetchMatrixOpinion())        
    }, [])

    const onSubmit = async data => {
        saveMatrixOpinion(data)
    }

    const saveMatrixOpinion = async data => {
        try {
            setSave(prev => ({...prev, loading: true}))
            const url = BASE_URL + "/api/matrixopinion";
            const response = await axios.post(url, data);
            setSave(prev => ({...prev, success: true, loading: false}))

            if (response.status === 200) {
                primeToast.current.show({
                    severity: 'success',
                    summary: 'success',
                    detail: 'Opinion Saved successfully',
                    life: 3000
                });
                setMatrixOpinionItem({
                    roleMatrixOpinionID: 0,
                    title: '',
                    description: "",
                    weight: 0,
                    active: true,    
                });
                setModal(!modal)
                dispatch(fetchMatrixOpinion())
            }
        } catch (e) {
            console.log(e)
            setSave(prev => ({...prev, success: false, loading: false, message: e.message}))
            primeToast.current.show({severity: 'error', summary: 'error', detail: 'An Error ', life: 3000});
        }
    }


    const onHide = () => {
        setModal(!modal)
        setMatrixOpinionItem({
            roleMatrixOpinionID: 0,
            title: '',
            description: "",
            weight: 0,
            active: true,    
        });
    }

    const editGridData = data => {
        setMatrixOpinionItem({
            roleMatrixOpinionID:data.roleMatrixOpinionID,
            title:data.title,
            description:data.description,
            weight:data.weight,
            active:data.active            
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'title': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'description': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },

            'weight': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end


    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Matrix
                    Opinion
                </button>
            </div>
        </div>
    );

    // const footer =`In total there are ${state.assesmentOpinion ? state.assesmentOpinion.length : 0} assestmentTitleIndicator.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={matrixOpinion} header={header} paginator rows={7} first={start}

                   showGridlines
                   dataKey="matrixOpinionID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['title', 'description', 'weight', 'active']}

                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="roleMatrixOpinionID" header="Opinion ID" hidden={true}/>
            <Column field='title' header="Title"/>
            <Column field='description' header="Description"/>
            <Column field='weight' header="Weight" hidden={false}/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false}
                    style={{minWidth: '4rem', textAlign: "center"}}/>
        </DataTable>
    )


    return <>
        <Layout>
            <Toast ref={primeToast}/>
            <MatrixOpinionForm
                onSubmit={onSubmit}
                onHide={onHide}
                modal={modal}
                title={matrixOpinionItem.title}
                description={matrixOpinionItem.description}
                active={true}
                isLoading={false}
                roleMatrixOpinionID={matrixOpinionItem.roleMatrixOpinionID}
                />
                
            {Table}
        </Layout>
    </>

}
export default MatrixOpinion